export class FilterType5 {
    constructor(

    ) {
        this.operation = 0;
        this.values = null;
    }
    public operation: number;
    public values: number[];

}



// WEBPACK FOOTER //
// ./src/app/stocks/models/filter-type-5.ts